"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
module.exports = angular.module("qwilr.aspectResize", []).directive("aspectResize", function () { return ({
    restrict: "A",
    link: function (scope, element, attrs) {
        element = element[0];
        var ratio = attrs.aspectResize;
        var parent = element.parentNode;
        while (!parent.offsetWidth || !parent.offsetHeight) {
            parent = parent.parentNode;
        }
        var setSize = function (width, height) {
            element.style.width = "".concat(width, "px");
            element.style.height = "".concat(height, "px");
            element.style.left = "".concat((parent.offsetWidth - width) / 2, "px");
            element.style.top = "".concat((parent.offsetHeight - height) / 2, "px");
        };
        var observer = (0, observe_rect_1.default)(parent, function (rect) {
            var width = rect.width;
            var height = rect.height;
            if (width > height * ratio) {
                return setSize(width, width * (1 / ratio));
            }
            else {
                return setSize(height * ratio, height);
            }
        });
        scope.$on("$destroy", function () {
            observer.unobserve();
        });
        observer.observe();
    },
}); });
